import { Box, Button, FormControl, Paper, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";


import { useNavigate } from "react-router-dom";
import configUrls from "../../../config/configUrls";
import errorFormat from "../../../utils/errorFormat";


import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { ISprocessoBloco, ProcessoBloco } from "../../../types/processo/ProcessoBloco";
import { ISusuario, Usuario } from "../../../types/usuario/Usuario";
import { useCreateDocumento1Mutation } from "../../iniciarDocumento/createDocumento/documentoApiSlice";
import { addDocumentoProcessoSelecioadoSlice } from "../processoSelecionadoSlice";
import { ProcessoBlocoForm } from "./ProcessoBlocoForm";
import { useAddAtribuirBlocoMutation } from "../processoApiSlice";
import { Bloco, ISbloco } from "../../../types/bloco/Bloco";


export const ProcessoBlocoCreate = () => {


    const [processoBloco, setProcessoBloco] = useState<ProcessoBloco>(ISprocessoBloco);
    const [blocoSelecionadoTemp, setInteressadoSelecionadoTemp] = useState<Bloco>(ISbloco);

    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [createBloco, status] = useAddAtribuirBlocoMutation();
    const navigate = useNavigate();


    //ler do RTK o processo selecionado    
    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!processoSelecionado) {
            // navigate(configUrls.PROCESSO_LIST_RT);
            window.location.href = configUrls.PROCESSO_LIST_RT
        } else {
            setProcessoBloco((prev) => ({
                ...prev,
                processoId: processoSelecionado.id
            }));
        }
    }, []);


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        setProcessoBloco((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };

    const handletxtblocoChange = (bloco: Bloco) => {
        setInteressadoSelecionadoTemp(bloco);
        setProcessoBloco((prev) => ({
            ...prev,
            blocoId: bloco.id,
        }));
    };


    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        const params = {
            processoId: processoBloco.processoId,
            observacao: processoBloco.observacao ?? undefined,
            usuarioId: null,
            blocoId: processoBloco.blocoId
        };

        await createBloco(params);
    }

    useEffect(() => {

        if (status.isError) {
            enqueueSnackbar("Registro não incluído!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro incluído!", { variant: "success" })
            // dispatch(addDocumentoProcessoSelecioadoSlice(status.data));
            navigate(-1);
            // setDocumento(ISdocumento);    
        }

    }, [status]);


    return (

        <>
            <Paper>




                <FormControl fullWidth>

                    <Box display="flex" justifyContent="space-between" mb={2}>

                        <Box display="flex">
                            <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                                Atribuição de Bloco para o Processo: {processoSelecionado?.numeroProcesso}
                            </Typography>

                        </Box>

                        <Box display="flex" justifyContent="flex-end" sx={{ padding: 2 }} gap={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small" // <-- Isso reduz o tamanho do botão
                                onClick={() => { navigate(configUrls.BLOCO_CREATE) }}
                            >
                                Novo Bloco
                            </Button>
                        </Box>
                    </Box>
                </FormControl>
















                <ProcessoBlocoForm
                    data={processoBloco}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                    handletxtBlocoChange={handletxtblocoChange}
                    blocoValueTmp={blocoSelecionadoTemp}
                />

            </Paper>
        </>
    );
};
